// =====================================
//  編輯會員資料 modal
//
//  @author: Gray
//  @time 2016 / 09 / 01
// =====================================

window.InifECMobileApp.directive('editMember', ['$rootScope', '$ngModal', '$timeout', 'UserService',
    function ($rootScope, $ngModal, $timeout, UserService) {

        var _dir = {};

        var controller = ['$scope', function($scope) {

            // -------------------------------
            // 更改會員資料
            // -------------------------------
            var submit = function() {

                // 檢查資料是否有正確填入
                var isError = false;
                $scope.isUserNameEmpty = false;
                $scope.isUserMobilePhoneEmpty = false;
                $scope.isUserMobilePhoneError = false;
                $scope.isUserPhoneError = false;
                $scope.isUserAddressEmpty = false;
                $scope.mobilephoneExistedError = false;

                if(!$scope.form.name) {
                    $scope.isUserNameEmpty = true;
                    isError = true;
                }

                if(!$scope.form.mobilephone) {
                    $scope.isUserMobilePhoneEmpty = true;
                    isError = true;
                }

                if($scope.form.mobilephone && !isPhone($scope.form.mobilephone)) {
                    $scope.isUserMobilePhoneError = true;
                    isError = true;
                }

                if($scope.form.phone && !isPhone($scope.form.phone)) {
                    $scope.isUserPhoneError = true;
                    isError = true;
                }

                if(!$scope.form.address || (!$scope.isBusinessMember && !$scope.form.newAddress)) {
                    $scope.isUserAddressEmpty = true;
                }

                if($scope.isUserNameEmpty || $scope.isUserMobilePhoneEmpty) {
                    $scope.isParamsMissing = true;
                    isError = true;
                }

                if($scope.isUserPhoneError || $scope.isUserMobilePhoneError || $scope.isUserAddressEmpty) {
                    $scope.isParamsError = true;
                    isError = true;
                }

                if(isError) {
                    return;
                }

                UserService.checkMobilephone($scope.form.mobilephone).then(function(result) {
                    if(result) {
                        var userInfo = {
                            name: $scope.form.name,
                            phone: $scope.form.phone,
                            phoneExtension: $scope.form.phoneExtension,
                            mobilephone: $scope.form.mobilephone,
                            postal: $scope.form.postal,
                            address: $scope.form.address,
                        };

                        var statusResult = {
                            isUserNameEmpty: $scope.isUserNameEmpty,
                            isUserMobilePhoneEmpty: $scope.isUserMobilePhoneEmpty,
                            isUserMobilePhoneError: $scope.isUserMobilePhoneError,
                            isUserPhoneError: $scope.isUserPhoneError,
                            isUserAddressEmpty: $scope.isUserAddressEmpty,
                            mobilephoneExistedError: $scope.mobilephoneExistedError,
                        };
                        
                        $scope.callback && $scope.callback(userInfo, statusResult);

                        closeModal();
                    } else {
                        $scope.mobilephoneExistedError = true;
                    }

                }, function(error) {
                    $scope.mobilephoneExistedError = true;
                })
            }

            // -------------------------------
            // 離開編輯會員資料
            // -------------------------------
            var cancel = function() {

                closeModal();
            }

            // -------------------------------
            //  開啟 modal
            // -------------------------------
            var openModal = function() {
                
                $ngModal.openModal('edit-member-modal');
            }

            // -------------------------------
            //  關閉 modal
            // -------------------------------
            var closeModal = function() {

                $ngModal.closeModal('edit-member-modal');
            }

            /*==========================
                Events
            ==========================*/            
            $scope.$on('OPEN_EDIT_MEMBER_MODAL', function(event, data) {
                
                if(data) {
                    $scope.form.name = data.name;
                    $scope.form.phone = data.phone;
                    $scope.form.phoneExtension = data.phoneExtension;
                    $scope.form.mobilephone = data.mobilephone;
                    $scope.form.city = '';
                    $scope.form.dist = '';
                    $scope.form.newAddress = '';
                    $scope.form.postal = data.postal;
                    $scope.form.address = data.address;

                    $scope.isUserNameEmpty = data.isUserNameEmpty;
                    $scope.isUserMobilePhoneEmpty = data.isUserMobilePhoneEmpty;
                    $scope.isUserMobilePhoneError = data.isUserMobilePhoneError;
                    $scope.isUserPhoneError = data.isUserPhoneError;
                    $scope.isUserAddressEmpty = data.isUserAddressEmpty;
                    $scope.mobilephoneExistedError = data.mobilephoneExistedError;
                    $scope.isBusinessMember = data.isBusinessMember;

                    $scope.callback = data.callback;

                    openModal();
                }
            });

            /*==========================
                Members
            ==========================*/
            $scope.form = {
                name: '',
                phone: '',
                phoneExtension: '',
                mobilephone: '',
                city: '',
                dist: '',
                postal: '',
                address: '',
                newAddress: '',
            }

            $scope.isBusinessMember = false;

            $scope.isUserNameEmpty = false;
            $scope.isUserMobilePhoneEmpty = false;
            $scope.isUserMobilePhoneError = false;
            $scope.isUserPhoneError = false;
            $scope.isUserAddressEmpty = false;
            $scope.mobilephoneExistedError = false;
            
            /*==========================
                Methods
            ==========================*/
            $scope.submit = submit; // 更改會員資料
            $scope.cancel = cancel; // 離開編輯會員資料
            $scope.callback = undefined;

            /*==========================
                init
            ==========================*/

        }]

        _dir.restrict = "E";
        _dir.scope = true;
        _dir.templateUrl = "mobile/partials/modal/edit_member.html";
        _dir.controller = controller;

        return _dir;
    }]
);